module.exports = __webpack_public_path__ + "static/media/wait_turn.2eec9c35.svg";